import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=24e8510e"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports